module.exports = __webpack_public_path__ + "static/2024-parallax-fdc2066be8ff5574bb2f27b2634da739.gif";